import { Button } from "semantic-ui-react";

function ExplicacaoSituacao({ situacaoId, onClickAtividade }) {
  const explicacaoDivulgado = () => (
    <>
      <p>
        O Diretório Municipal tem 7 dias úteis para analisar seu pedido de
        filiação.
        <p>
          A gente te avisa por e-mail, mas você também poderá acompanhar tudo
          por aqui.
        </p>
      </p>
    </>
  );

  const explicacaoImpugnado = () => (
    <>
      <p>Seu pedido de filiação foi impugnado!</p>
      <p>
        O Diretório Municipal deverá comunicar formalmente os motivos da
        impugnação para que você possa se defender em até 7 dias úteis.
      </p>
    </>
  );

  const explicacaoAguardandoAtividade = () => {
    return (
      <>
        <p>Você precisa assistir o vídeo de boas vindas antes de prosseguir</p>
        <p style={{ textAlign: "center" }}>
          <Button className="btn-link" onClick={onClickAtividade}>
            Assistir agora
          </Button>
        </p>
      </>
    );
  };

  const explicacaoRecusado = () => (
    <>
      <p>O Diretório Municipal recusou seu pedido de filiação.</p>
      <p>
        Se você não foi comunicado formalmente, por favor,{" "}
        <a
          href="https://pt.org.br/diretorios-estaduais/"
          className="linkTexto"
          target="_blank"
          rel="noreferrer"
        >
          clique aqui
        </a>{" "}
        e procure o Diretório do PT no seu Estado.
      </p>
    </>
  );

  const explicacaoAprovado = () => (
    <>
      <p>
        <strong>Você agora é petista de carteirinha!</strong>
      </p>
      <p>
        Agora você pode se engajar nas atividades organizadas pelo seu Diretório
        Municipal. Enviamos uma senha no seu email e você já pode acessar a Área
        PT, espaço do nosso site reservado para os filiados e filiadas.
      </p>
    </>
  );

  return (
    <div className="textoExplicativo">
      {situacaoId === 2 ? explicacaoDivulgado() : null}
      {situacaoId === 3 ? explicacaoImpugnado() : null}
      {situacaoId === 4 ? explicacaoAguardandoAtividade() : null}
      {situacaoId === 5 ? explicacaoRecusado() : null}
      {situacaoId === 6 ? explicacaoAprovado() : null}
      <a
        style={{ color: "#fff" }}
        className="ui primary button buttonAcao"
        href="https://pt.org.br"
      >
        Concluir
      </a>
    </div>
  );
}

export default ExplicacaoSituacao;
